export default class VashtiePage {
    constructor() {
        const registerVashtiePanel = document.querySelector('.register-vashtie');

        jQuery(document).on('cloroxPreferenceCenterNewsletter', () => {
            registerVashtiePanel.innerHTML = `
        <div id="vashtie-signup-success">
        <h3>YOU'RE ON THE LIST!</h3>
        <p>Thanks for joining us and signing up for our newsletter. We’ll let you know when the Pine-Sol<sup>&reg;</sup> X Vashtie collab is available. Until then, feel free to explore the <a href="/pine-store/">Pine-Store</a>™ for more fresh gear and gifts.</p>
        </div>
      `;
        });
    }
}
